// extracted by mini-css-extract-plugin
export default {"base":"vp_jiuFV","disclaimer":"vp_PhD1t","noBar":"vp_ylwsG","hasSidebar":"vp_miV4A"};